import React from 'react';

//const FORM_INVALID_STATE = 1;

class FotoBlock extends  React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        picture_meal : this.props.picture_meal,
        picture_selfie : this.props.picture_selfie
      };
     
      
      this.handlePictureMealChange = this.handlePictureMealChange.bind(this);
      this.handlePictureSelfieChange = this.handlePictureSelfieChange.bind(this);

      this.clickSelfieUploader = this.clickSelfieUploader.bind(this);
      this.clickMealUploader = this.clickMealUploader.bind(this);
      this.uploadFile = this.uploadFile.bind(this);

      this.removeSelfie = this.removeSelfie.bind(this);
    this.removeMeal = this.removeMeal.bind(this);
    }
    removeSelfie(e) {
      
      e.preventDefault();
      this.props.onPictureSelfieChange( '' );
      this.setState({ picture_selfie: '' });
    }
    removeMeal(e) {
      e.preventDefault();
      this.props.onPictureMealChange( '' );
      this.setState({ picture_meal: '' });
    }
    handlePictureMealChange(selectorFiles: FileList) {
      for (let i=0; i < selectorFiles.length;i++) {
          let file = selectorFiles[i];
          this.uploadFile(file,'picture_meal');
      }    
    }

    handlePictureSelfieChange(selectorFiles: FileList) {
       for (let i=0; i < selectorFiles.length;i++) {
        let file = selectorFiles[i];
        this.uploadFile(file,'picture_selfie');
       }   
    }

    clickSelfieUploader(e) {
      this.selfieUploader.click();
    }
    clickMealUploader(e) {
      this.mealUploader.click();
      
    }
     uploadFile(file,file_type){
      var url = 'https://odernichtoderdoch.de/addons/rezepte/uploadimage';
      var xhr = new XMLHttpRequest();
      var fd = new FormData();
      xhr.open("POST", url, true);
      //xhr.setRequestHeader("Content-Type","multipart/form-data");
      let _this = this;
      xhr.onreadystatechange = function() {
          if (xhr.readyState === 4 && xhr.status === 200) {
              // Every thing ok, file uploaded
              try {

                let UploadResponse = JSON.parse( xhr.responseText);  
                console.log(file_type);
                if(file_type === 'picture_meal') {
                  _this.props.onPictureMealChange( UploadResponse.ObjectURL);
                  _this.setState({ picture_meal: UploadResponse.ObjectURL });
                }
                if(file_type === 'picture_selfie') {
                  _this.props.onPictureSelfieChange( UploadResponse.ObjectURL);
                  _this.setState({ picture_selfie: UploadResponse.ObjectURL });
                }
              }
              catch (error) {
                console.log(error);
                _this.setState({ errorMessageText: 'Leider lief etwas schief! Bitte  versuche ein anderes/kleineres Bild' });
                _this.props.onErrorMessageText('Leider lief etwas schief! Bitte versuche ein anderes/kleineres Bild');
              }
          
          }
          console.log(xhr);
      };
    
      if ( xhr.upload ) {
          xhr.upload.onprogress = function(e) {
              var done = e.position || e.loaded, total = e.totalSize || e.total;
              console.log('xhr.upload progress: ' + done + ' / ' + total + ' = ' + (Math.floor(done/total*1000)/10) + '%');
          };
      };
      fd.append("upload_file", file);
      fd.append("file_type",file_type);
      xhr.send(fd);
  }

    render() {
          let imageMealPreview = null;
          let deleteVisibleMeal = 'delete-button pictures';
          if (this.state.picture_meal !== '') {
            imageMealPreview = <img src={this.state.picture_meal} className="preview" alt="Vorschau Mahlzeit"  onClick={ (e) => this.clickMealUploader(e) }  />;
            deleteVisibleMeal =  'delete-button pictures visible';
          } else {
            imageMealPreview = <img className="uploadbutton" src="/images/i_foto_gericht.svg" alt="Vorschau Mahlzeit" onClick={ (e) => this.clickMealUploader(e) }  />;
            deleteVisibleMeal =  'delete-button pictures hidden';
          }
           
          let imageSelfiePreview = null;
          let deleteVisibleSelfie =  'delete-button pictures';
          if (this.state.picture_selfie !== '') {
            imageSelfiePreview = <img src={this.state.picture_selfie} className="preview" alt="Vorschau von Dir!"  onClick={ (e) => this.clickSelfieUploader(e) }  />;
            deleteVisibleSelfie =  'delete-button pictures visible';
          } else {
            imageSelfiePreview = <img className="uploadbutton" src="/images/i_foto_person.svg" alt="Vorschau Selfie"  onClick={ (e) => this.clickSelfieUploader(e) }  />;
            deleteVisibleSelfie =  'delete-button pictures hidden';
          } 
          //let imageMealPreviewValid =  ((this.props.picture_mealIsValid === FORM_INVALID_STATE) ? 'invalid' : 'valid');
         // let imageSelfiePreviewValid =  ((this.props.picture_selfieIsValid === FORM_INVALID_STATE) ? 'invalid' : 'valid');
          
      return (
        
        <div className="Component Fotos">
            <div className="center">
              <img className="photo_uploader_title" src="/images/i_titel_h4_fotoshochladen.svg" alt="Foto hochladen" />
              <p>Ein schönes Foto von dir und eins von deinem zubereiteten Rezept.</p>
            </div>         
            <section className="flex2">
            <div className="uploader">
            {imageSelfiePreview}

              <img className="uploadbutton hidden" src="/images/uploadbtn.svg" alt="Lade ein Foto von dir hoch" onClick={ (e) => this.clickSelfieUploader(e) } />
              <input type="file" onChange={ (e) => this.handlePictureSelfieChange(e.target.files) } ref={(input) => { this.selfieUploader = input; }} />
              <button className={deleteVisibleSelfie}  onClick={ (e) => this.removeSelfie(e) } >Löschen</button>
             
            </div>
            <div className="uploader">
            {imageMealPreview}
              <img className="uploadbutton hidden" src="/images/uploadbtn.svg" alt="Lade ein Foto von deinem zubereiteten Rezept hoch" onClick={ (e) => this.clickMealUploader(e) }  />
              <input type="file" onChange={ (e) => this.handlePictureMealChange(e.target.files) } ref={(input) => { this.mealUploader = input; }}/>
              <button className={deleteVisibleMeal}  onClick={ (e) => this.removeMeal(e) } >Löschen</button>
            </div>
          </section>
      </div>
           
      );
    }
  }

  export default FotoBlock;


// WEBPACK FOOTER //
// ./src/FotoBlock.js